import React from "react";
import { Box, Typography, Alert, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import BasePaper from "components/Base/BasePaper";

const ValidationResults = ({ validation }: { validation: any }) => {
  if (!validation) return null;

  return (
    <BasePaper>
      <Alert severity={validation.invalid_rows > 0 ? "warning" : "success"} sx={{ mt: 2 }}>
        {validation.valid_rows} valid rows, {validation.invalid_rows} invalid rows.
      </Alert>

      <Table size="small" sx={{ mt: 3 }}>
        <TableHead>
          <TableRow>
            <TableCell><strong>Row</strong></TableCell>
            <TableCell><strong>Status</strong></TableCell>
            <TableCell><strong>Errors</strong></TableCell>
          </TableRow>
        </TableHead>
        
        <TableBody>
          {validation.rows.map((r: any) => (
            <TableRow key={r.row}>
              <TableCell>{r.row + 1}</TableCell>
              <TableCell>{r.valid ? "✅ Valid" : "❌ Invalid"}</TableCell>
              <TableCell>
                {!r.valid &&
                  Object.entries(r.errors).map(([field, msg]) => (
                    <div key={field}>{field}: {String(msg)}</div>
                  )
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </BasePaper>
  );
};

export default ValidationResults;
